import { LINK } from '@constants';
import { ArrowRight, Button, Column, Empty, Typography } from '@viewup/ui';
import {
  PostCampaignStatus,
  PostViewingTypeCode,
  useGetActiveNBlogAccount,
  useGetPostCampaignOverview,
} from 'app/viewing/_entities/post';
import { CheckBeforeApplyButton } from 'app/viewing/_features/post';
import dayjs from 'dayjs';
import { useRouter } from 'next/navigation';
import { DeductCard } from '../DeductCard';
import { DraftCard } from '../DraftCard';
import { SubmittedCard } from '../SubmittedCard';

export const OverviewPostCampaignList = () => {
  const router = useRouter();
  const { data: blogAccount } = useGetActiveNBlogAccount();
  const { data: response } = useGetPostCampaignOverview(blogAccount?.accountUuid || '');
  const campaigns = response?.campaigns;
  const isEmpty = (campaigns?.length || 0) <= 0;

  return (
    <Column css={{ height: '100%', overflow: 'auto' }} gap={16} height={'100%'}>
      <CheckBeforeApplyButton />
      {isEmpty && (
        <Column alignItems='center' height={'calc(100svh - 352px)'} justifyContent='center'>
          <Column alignItems='center' gap={8} justifyContent='center' width={'100%'}>
            <Empty />
            <Typography color='text.tertiary' fontType='body.medium' mt={40}>
              포스팅 뷰업을 신청해 주세요.
            </Typography>
          </Column>
        </Column>
      )}

      {campaigns?.map(
        ({
          status,
          appliedAt,
          campaignName,
          description,
          guidelineUrl,
          rewardPoint,
          submitLimitTime,
          campaignUuid: uuid,
          penaltyPoint,
          options,
          isGuidelineUpdated,
          postViewingRecordUuid,
        }) => {
          if (status === PostCampaignStatus.APPLY_SUCCESS)
            return (
              <DraftCard
                accountUuid={blogAccount?.accountUuid || ''}
                applicationDate={dayjs(appliedAt).format('YY.MM.DD')}
                campaignUuid={uuid}
                description={description}
                guidelineUrl={guidelineUrl}
                isGuidelineUpdated={isGuidelineUpdated}
                key={uuid}
                name={campaignName}
                options={options}
                postViewingRecordUuid={postViewingRecordUuid}
                rewardPoint={rewardPoint}
                submitLimitTime={submitLimitTime}
                typeCode={PostViewingTypeCode.NBLOG_BLOG_LITE}
              />
            );

          if (status === PostCampaignStatus.SUBMITTED)
            return (
              <SubmittedCard
                applicationDate={dayjs(appliedAt).format('YY.MM.DD')}
                campaignUuid={uuid}
                key={uuid}
                name={campaignName}
                status={PostCampaignStatus.SUBMITTED}
              />
            );

          if (status === PostCampaignStatus.EARNING_SUCCESS)
            return (
              <SubmittedCard
                applicationDate={dayjs(appliedAt).format('YY.MM.DD')}
                campaignUuid={uuid}
                earningPoint={rewardPoint}
                key={uuid}
                name={campaignName}
                status={PostCampaignStatus.EARNING_SUCCESS}
              />
            );

          if (
            status === PostCampaignStatus.DEVIATION ||
            status === PostCampaignStatus.NOT_SUBMITTED ||
            status === PostCampaignStatus.REJECT
          )
            return (
              <DeductCard
                applicationDate={dayjs(appliedAt).format('YY.MM.DD')}
                campaignUuid={uuid}
                deductionAmount={penaltyPoint || 0}
                deductReason={status}
                key={uuid}
                name={campaignName}
                rewardPoint={rewardPoint}
              />
            );

          return null;
        },
      )}

      <Button
        css={{ margin: '0 auto' }}
        onClick={() => router.push(LINK.VIEWING_POST_HISTORY)}
        rightContent={<ArrowRight />}
        size='S'
        variant='ghost.assistive'
      >
        더 많은 참여기록 보기
      </Button>
    </Column>
  );
};
